import { render, staticRenderFns } from "./kjqgIndex.vue?vue&type=template&id=dccde814&scoped=true&"
import script from "./kjqgIndex.vue?vue&type=script&lang=js&"
export * from "./kjqgIndex.vue?vue&type=script&lang=js&"
import style0 from "./kjqgIndex.vue?vue&type=style&index=0&id=dccde814&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccde814",
  null
  
)

export default component.exports